import list from "@/pages/incoming/list";
import add from "@/pages/incoming/add";
import edit from "@/pages/incoming/edit";


const routes = [
  {
    path: "/incoming/Manage",
    component: list,
    meta: {requiredAuth: true},
  },
  {
    path: "/incoming/Edit/:id",
    component: edit,
    meta: {requiredAuth: true},
  },
  {
    path: "/incoming/Add/:customer_id?",
    component: add,
    meta: {requiredAuth: true},
  },
]

export default routes